import styled from "styled-components";
import { HeadKeyStyle,HeadKeyStyleDiv } from "../../styles";
import { GhostButtonComponent } from "../../../../../../CommonComponents/commonStyles";

export const MainHead = styled.h1`
  font-family: HelveticaNeue-Bold;
  font-size: 24px;
  line-height: 1;
  color: #022737;
  margin-bottom: 30px;
  padding-top: ${props => props.paddingTop};

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 20px;
  }
`;

export const DeliveryWrap = styled.div`
  margin-bottom: 0;
`;

export const SubHead = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  letter-spacing: 0px;
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom: 20px;
`;

export const SubHeadTitle = styled(SubHead)`
  margin-bottom: 13px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 5px;
    font-size: ${props => props.theme.fontSize.secondary};
  }
  display: flex;
  align-items: center;
  padding-top: ${props => props.paddingTop};
  font-size: ${props => props.theme.fontSize.primary};
`;

export const ImageWrap = styled.img`
  margin-right: 10px;
`;

export const KeyStyle = styled(HeadKeyStyle)`
  line-height: ${props => props.lineHeight};
  margin: 0;
  color: ${props => props.theme.fontColors.textColor};
  margin-left: ${props => props.marginLeft};
`;

export const KeyStyleAddress = styled(HeadKeyStyleDiv)`
  line-height: ${props => props.lineHeight};
  margin: 0;
  color: ${props => props.theme.fontColors.textColor};
  margin-left: ${props => props.marginLeft};
`;

export const ValueStyle = styled(KeyStyle)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  line-height: ${props => props.lineHeight};
  margin-left: ${props => props.marginLeft};
  max-width: calc(100% - 30px);
  overflow-wrap: break-word;
  color: ${props => props.theme.fontColors.headingColor};
`;

export const ValueStylePrimary = styled(KeyStyle)`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
line-height: ${props => props.lineHeight};
margin-left: ${props => props.marginLeft};
max-width: 50%;
overflow-wrap: break-word;
vertical-align: top;
display: inline-block;
`;

export const PhoneInfoWrapMain = styled.div`
  margin-bottom: 30px;
`;

export const PhoneInfoWrap = styled.div`
  margin-left: 30px;
  // display: flex;
  // align-items: baseline;
`;
export const AdressInfoWrap = styled.div`
  margin-left: 30px;
  display: block;
  align-items: baseline;
`;
export const AdressInfoInner = styled.div`
  display: flex;
  align-items: baseline;
`;
export const GhostButtonComponentStyles = styled(GhostButtonComponent)`
  width: 67px;
  height: 18px;
  font-size: 10px;
  line-height: 2.4;
  margin-left: 10px;
  font-family: HelveticaNeue-Bold;
  padding: 0 10px;
  display: inline;

  span {
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 67px;
  }
`;

export const DividerWrap = styled.div`
  margin: 0;
  .ant-divider {
    color: #bfbfbf !important;
    background: #bfbfbf !important;
  }
  padding-top: ${props => props.paddingTop};
  padding-bottom: ${props => props.paddingBottom};

  .ant-divider-horizontal {
    margin: 20px 0 50px 0 !important;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin: ${props => props.margin && '-10px 0 20px 0 !important'};
    }
  }
`;

export const BorderRight = styled.div`
  border-right: 1px solid #bfbfbf;
  padding-right: 10px;
  margin-right: 40px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    border-right: none;
    margin-right: 0px;
  }
`;

export const AddMarginSpace = styled.div`
  margin-top: 15px;
  margin-bottom: 30px;
`;
